"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PosWithOffersMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class PosWithOffersMapper {
    toDomain(result) {
        const data = lodash_1.default.get(result, "data.getFilteredPoswithOffersAndMenus");
        const isLoading = lodash_1.default.get(result, "loading");
        return {
            data,
            isLoading,
        };
    }
}
exports.PosWithOffersMapper = PosWithOffersMapper;
